
module.exports = {
  // TODO: change your profile information here
  name: "Darshan Hirekurubar",
  greeting: "Hey 👋",
  greetingDescription: "I'm Darshan Hirekurubar and I'm a Software Engineer!",
  githubUrl: "https://github.com/darshan4416",
  linkedinUrl: "https://www.linkedin.com/in/darshan-hirekurubar-326389183/",
  cvLink: "/",
};
